import React, { useEffect, useState } from 'react'
import { eye_icon, left_arrow } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';

const UpcomingView = () => {
    const [adult, setAdult] = useState();
    const [child, setChild] = useState();
    const [blockDates, setBlockDates] = useState();
    const [blockToDates, setBlockToDates] = useState();
    const navigate = useNavigate()
    const location = useLocation()
    const bookingData = location?.state?.bookingData;
    console.log("booking", bookingData);


    useEffect(() => {
        setChild(bookingData?.booking_rooms?.map((item) => {
            return (
                item?.no_of_childs
            )
        }))
        setAdult(bookingData?.booking_rooms?.map((item) => {
            return (
                item?.no_of_adults
            )
        }))
        setBlockDates(bookingData?.from_date)
        setBlockToDates(bookingData?.to_date)
    }, [])

    console.log('datum', bookingData)
    return (
        <div className="dashRightView home_section">
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
                    Bookings - UpComing
                </h2>
            </div>

            <div className='d-flex ac-js gap-2'
                onClick={() => navigate(-1)}
            >
                <img src={left_arrow} className='leftArrow mb-3' />
                <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
            </div>
            <div className="">
                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Booking ID
                        </h4>
                        <input type="text" value={bookingData?.booking_id} disabled className="input-pop ps-2 w-100" placeholder="Booking ID" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Property Name
                        </h4>
                        <input type="text" value={bookingData?.property?.name} disabled className="input-pop ps-2 w-100" placeholder="Property Name" />
                    </div>
                </div>
                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Owner Name
                        </h4>
                        <input type="text" value={bookingData?.property?.owner?.name} disabled className="input-pop ps-2 w-100" placeholder="Owner Name" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            User Name
                        </h4>
                        <input type="text" value={bookingData?.user?.name} disabled className="input-pop ps-2 w-100" placeholder="User Name" />
                    </div>
                </div>
                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Check in Time
                        </h4>
                        <input type="text" value={`${moment(bookingData?.from_date).format("DD-MM-YYYY") || ""}, ${bookingData?.check_in || ""}`} disabled className="input-pop ps-2 w-100" placeholder="Pricing" />
                    </div>
                    {/* <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Checked in Time
                        </h4>
                        <input type="text" value={`${moment(bookingData?.from_date).format("DD-MM-YYYY") || ""}, ${bookingData?.check_in || ""}`} disabled className="input-pop ps-2 w-100" placeholder="Type" />
                    </div> */}
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Check out Time
                        </h4>
                        <input type="text" value={`${moment(bookingData?.to_date).add(1, "days").format("DD-MM-YYYY") || ""}, ${bookingData?.check_out || ""}`} disabled className="input-pop ps-2 w-100" placeholder="Type" />
                    </div>
                </div>
                <div className='d-flex gap-5 mb-4'>

                    {/* <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Checked out Time
                        </h4>
                        <input type="text" value={`${moment(bookingData?.to_date).format("DD-MM-YYYY") || ""}, ${bookingData?.check_out || ""}`} disabled className="input-pop ps-2 w-100" placeholder="Type" />
                    </div> */}
                </div>

                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Booking ON
                        </h4>
                        <input type="text" value={moment(bookingData?.created_at).format("DD-MM-YYYY")} disabled className="input-pop ps-2 w-100" placeholder="Booking ON" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Booking Dates
                        </h4>
                        <input type="text" value={`${moment(bookingData?.from_date).format("DD-MM-YYYY") || ""}, ${moment(bookingData?.to_date).format("DD-MM-YYYY") || ""}`} disabled className="input-pop ps-2 w-100" placeholder="Booking Dates" />
                    </div>


                </div>
                <div className='d-flex gap-5 mb-4'>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Pricing
                        </h4>
                        <input type="text" value={bookingData?.total_amount} disabled className="input-pop ps-2 w-100" placeholder="Pricing" />
                    </div>
                    <div className='col-md-5'>
                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                            Type
                        </h4>
                        <input type="text" value={bookingData?.property?.property_type == 1 ? "Rooms" : bookingData?.property?.property_type == 2 ? "Individual" : ""} disabled className="input-pop ps-2 w-100" placeholder="Type" />
                    </div>
                </div>
                <div className='d-flex gap-5 mb-4'>
                    {bookingData?.property?.property_type == 1 && (
                        <div className='col-md-5'>
                            <div>
                                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                    Room Category
                                </h4>
                                <input type="text" value={bookingData?.room_category?.name == null ? "Null" : bookingData?.room_category?.name} disabled className="input-pop ps-2 w-100" placeholder="Room Category" />
                            </div>
                        </div>
                    )}

                    <div className='col-md-5'>
                        {bookingData?.booking_rooms?.map((item, index) => {
                            return (
                                <div className=' mb-4 w-100'>
                                    {/* {bookingData?.property?.property_type == 1 && (
                                <div className='col-md-5'>
                                    <div>
                                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                            Room Category
                                        </h4>
                                        <input type="text" value={bookingData?.room_category?.name == null ? "Null" : bookingData?.room_category?.name} disabled className="input-pop ps-2 w-100" placeholder="Room Category" />
                                    </div>
                                </div>
                            )} */}
                                    <div className='w-100'>
                                        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                            Room {index + 1}
                                        </h4>
                                        <div className='d-flex gap-3'>
                                            <div className="w-50 d-flex ac-js gap-2" >
                                                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  primary1">  Adults</h4>
                                                <input type="text" value={item?.no_of_adults} className="input-pop ps-2 w-100" placeholder="Adult : 10" />
                                            </div>
                                            <div className="w-50 d-flex ac-js gap-2">
                                                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18  primary1">  Childs</h4>
                                                <input type="text" value={item?.no_of_childs} className="input-pop ps-2 w-100" placeholder="Children : 10" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

        </div>
    )
}

export default UpcomingView